
import $ from 'jquery';
import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import { vSelectInModalWithPopper, WindowType } from '../../../../util';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { Board, CardAttributeDefinition, CardAttributeDefinitionType } from '../../../backend/backendapi';
import Spinner from '../../../util/Spinner';
import { handleError } from '../../../../api';
import { KanbanState } from '../../kanban.model';
import VueFormBuilder from './VueFormBuilder/VueFormBuilder';

declare var window: WindowType;

@Component({
  components: {
    Spinner,
    VueFormBuilder,
    vSelect,
  },
})
export default class EditModal extends Vue {
  @Inject()
  readonly state!: KanbanState;

  board: Board | null = null;
  attribute: CardAttributeDefinition | null = null;
  saving = false;

  CardAttributeDefinitionType = CardAttributeDefinitionType;
  vSelectInModalWithPopper = vSelectInModalWithPopper;

  get canScript(): boolean {
    return window.application.permissions.kanban.scripting;
  }

  get metaData(): string {
    return this.attribute?.metaData ?? '';
  }

  set metaData(metaData: string) {
    if (!this.attribute) {
      return;
    }
    this.attribute.metaData = metaData;
  }

  get vueFormMetaData(): string {
    return this.metaData.trim() || '{}';
  }

  set vueFormMetaData(metaData: string) {
    this.metaData = metaData;
  }

  get modalSizeClass() {
    return {
      'modal-xs': this.attribute?.type !== CardAttributeDefinitionType.Form,
      'modal-xl': this.attribute?.type === CardAttributeDefinitionType.Form,
    };
  }

  get types(): { id: number, name: string }[] {
    return Object.keys(CardAttributeDefinitionType)
        .filter(k => typeof CardAttributeDefinitionType[k as any] === 'number')
        .filter(k => !['Object', 'GPS'].includes(k))//none-visible types
        .map(k => {
          return { id: CardAttributeDefinitionType[k], name: k };
        });
  }

  get uid(): void {
    return this._uid;
  }

  public open(board: Board, attribute: CardAttributeDefinition): void {
    this.board = board;
    this.attribute = CardAttributeDefinition.fromJS(attribute); //deep copy for editing
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    this.attribute = null;
    $(this.$refs.modal!).modal('hide');
  }

  async save(): Promise<void> {
    if (!this.board || !this.attribute) {
      return;
    }

    this.saving = true;
    try {
      this.board.attributeDefinitions ??= [];
      if (this.attribute.id === 0) {
        const res = await this.state.attributeDefinitionAPI.create(this.attribute);
        this.board.attributeDefinitions.push(res.result!);
      } else {
        const res = await this.state.attributeDefinitionAPI.update(this.attribute);
        let index = this.board.attributeDefinitions.findIndex(e => e.id === res.result!.id);
        if (index >= 0) {
          Object.assign(this.board.attributeDefinitions[index], res.result!);
        } else { //the else case should not happen
          this.board.attributeDefinitions.push(res.result!);
        }
      }
      this.$toasted.info(this.$t('txtSaved').toString());
      this.dismiss();
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    } finally {
      this.saving = false;
    }
  }
}
